module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/maestro-bca14f07ae69ab2d054574a76d7e9088.svg";